import React from 'react';
import PropTypes from 'prop-types';

import {Box} from 'views/components';
import {Translate, translate} from 'views/module';

import Pill from './Pill';

const StagePill = (props) => {
  const {leadQuality, status} = props;

  const stageData = translate(`loomLead.Status.${status}`);
  const leadQualityColor = leadQuality && translate(`loomLead.LeadQuality.${leadQuality}.Color`);

  return (
    <Pill
      backgroundColor={stageData.Color || 'transparent'}
      borderColor={stageData.ColorBorder || stageData.Color || 'transparent'}
      label={
        <Box sx={{display: 'inline-flex', alignItems: 'center', gap: '6px'}}>
          {
            leadQualityColor &&
            <Box
              sx={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                backgroundColor: leadQualityColor,
                flexShrink: 0,
              }}
            />
          }
          <Translate expression={`loomLead.Status.${status}.Title`} />
        </Box>
      }
      textColor={stageData.ColorText || '#000000'}
    />
  );
};

StagePill.propTypes = {
  leadQuality: PropTypes.string,
  status: PropTypes.string.isRequired,
};

export default StagePill;
